<div class="modal fade" id="addNewSubject" tabindex="-1" aria-labelledby="addNewSubjectLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="border-0 shadow modal-content rounded-4 subject-modal">
      <form [formGroup]="form" (ngSubmit)="onSave()">
        <div class="py-5 modal-header px-7">
          <h4 class="modal-title fw-bold text-dark" id="addNewSubjectLabel">
            รายวิชา
          </h4>

          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="clearForm()"></button>
        </div>

        <div class="px-10 py-8 modal-body">
          <div class="row g-6">
            <div class="col-md-6">
              <app-select formControlName="academicTermYear" label="ปีการศึกษา" [options]="yearOptions"
                [required]="true" [searchable]="false" [isDisabled]="isTermDisabled" errorMessage="กรุณาเลือกปีการศึกษา"
                [error]="form.get('academicTermYear')?.touched && form.get('academicTermYear')?.invalid"
                (inputChange)="onYearChange($event)"></app-select>
            </div>
            <div class="col-md-6">
              <app-select formControlName="academicTermName" label="เทอมการศึกษา" [options]="termOptions"
                bindLabel="name" bindValue="name" [required]="true" [searchable]="false" [isDisabled]="isTermDisabled"
                errorMessage="กรุณาเลือกเทอมการศึกษา"
                [error]="form.get('academicTermName')?.touched && form.get('academicTermName')?.invalid"></app-select>
            </div>



            <div class="col-md-6">
              <app-input formControlName="code" label="รหัสวิชา" [required]="true" [isDisabled]="isCodeDisabled"
                errorMessage="กรุณากรอกรหัสวิชา"
                [error]="form.get('code')?.touched && form.get('code')?.errors"></app-input>
            </div>

            <div class="col-md-6">
              <app-input formControlName="name" label="ชื่อรายวิชา" [required]="true"
                errorMessage="กรุณากรอกชื่อรายวิชา"
                [error]="form.get('name')?.touched && form.get('name')?.errors"></app-input>
            </div>
          </div>

          @if (isEditMode && lastEditedAt; as lastEdited) {
            <div class="d-flex align-items-center text-muted fs-7 mt-6">
              <app-keenicon name="user-edit" class="fs-7 me-2"></app-keenicon>
              <span>แก้ไขล่าสุดโดย {{ lastEditedByName ?? 'ระบบ' }} • {{ lastEdited | customDate:'DD MMM YYYY HH:mm' }} น.</span>
            </div>
          }
        </div>

        <div class="px-10 pt-2 pb-8 border-0 modal-footer">
          <button type="button" class="btn btn-secondary btn-lg fw-bold me-4" data-bs-dismiss="modal"
            (click)="clearForm()">
            {{ "COMPONENT.CANCEL" | translate }}
          </button>

          <button type="submit" class="text-white btn btn-lg fw-bold me-4 subject-save-button" [disabled]="isSaving">
            {{ "COMPONENT.SAVE" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<app-confirm-dialog
  #saveSubjectConfirmDialog
  modalId="saveSubjectConfirm"
  icon="warning"
  title="ยืนยันการบันทึกข้อมูล"
  message="คุณต้องการบันทึกข้อมูลนี้ใช่หรือไม่ ?"
  cancelText="ยกเลิก"
  confirmText="ยืนยัน"
  [isProcessing]="isSaving"
  (confirmed)="onConfirmSave()"
></app-confirm-dialog>
